<template>
  <div>
    <select class="common_select" @change="onChange">
      <option v-for="(item, n) in items" :key="n" :value="item.value" :selected="item.selected">
        {{item.name}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectYear",
  props: {
    value: String,
  },
  data: () => ({
    items: [],
  }),
  computed: {
  },
  methods: {
    onChange(evt) {
      this.items.forEach((item, i) => {
         item.selected = i === evt.srcElement.selectedIndex ? true : false;
      });
      let selected = this.items.filter((item) => {
        return item.selected;
      });
      this.$emit("input", selected[0].value);
    },
  },
  created() {
    let year = (new Date()).getFullYear();
    for (let i = 0; i < 10; i++) {
      this.items.push({ name: this.$i18n.translate(`{0}년도`, (year - i)), value: `${year - i}`, selected: false});
      if(year - 1 < 2022){
        break;
      }
    }
  },
  beforeMount() {
    let me = this;
    this.items.forEach((item) => {
      item.selected = (item.value === me.value ? true : false);
    });
  },
}
</script>
